<template>
  <!-- ---- -->
  <!-- Logo -->
  <!-- ---- -->
  <v-container class="header" fluid style="width: 100%">
    <v-app-bar class="primary">
      <v-row class="pl-5" align="center">
        <!-- Force GET request on index.html on logo click -->
        <v-btn text class="p-10" onclick="window.location.href = '/accueil'">
          <v-img src="@/assets/SAQ_white.png" contain max-width="100" />
        </v-btn>

        <v-row class="pa-0 pl-5">
          <v-col cols="5" sm="2" class="font-weight-bold pa-0">
            <v-btn v-if="connecte" text medium active-class="secondary" class="white--text"
              style="text-transform: none;" @click="afficherCreerCommande()">
              <v-icon text class="pr-1">shopping_cart</v-icon>
              <div class="h4">Créer une nouvelle commande</div>
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="pa-0">
          <v-col cols="5" sm="2" class="font-weight-bold pa-0 pb-6">
            <v-btn v-if="connecte" :to="{ name: 'produitDisponible' }" text medium active-class="secondary"
              class="white--text" style="text-transform: none;">
              <v-icon text class="pr-1">search</v-icon>
              <div>Mes produits disponibles</div>
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="pa-0">
          <v-col cols="5" sm="2" class="font-weight-bold pa-0 pb-6">
            <v-btn v-if="connecte" :to="{ name: 'recherche' }" text medium active-class="secondary" class="white--text"
              style="text-transform: none;">
              <v-icon text class="pr-1">search</v-icon>
              <div>Recherche</div>
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="pa-0">
          <v-col cols="5" sm="2" class="font-weight-bold pa-0 pb-6">
            <v-btn v-if="connecte" :to="{ name: 'rapports' }" text medium active-class="secondary"
              style="text-transform: none;" class="white--text">
              <v-icon text class="pr-1">wysiwyg</v-icon>
              <div class="h4">Rapports</div>
            </v-btn>
          </v-col>
        </v-row>

        <v-spacer />

        <v-btn v-if="connecte" :to="{ name: 'profilEdit' }" text active-class="secondary"
          class="white--text text-none hidden-sm-and-down ml-3">
          <v-icon text class="pr-1">account_box</v-icon>
          <span class="text-subtitle-2" style="text-decoration: underline;color: white;">Bonjour, {{ nom
            }}</span></v-btn>

        <!--
        <v-btn icon>
          <v-icon v-if="!francais" color="white" @click="changeLocale('fr')"
            >language</v-icon
          >
          <v-icon v-else color="white" @click="changeLocale('en')"
            >language</v-icon
          >
        </v-btn>-->

        <v-btn icon>
          <v-icon v-if="connecte" color="white" @click="logout()">power_settings_new</v-icon>
        </v-btn>
      </v-row>
    </v-app-bar>
    <!--
    <div class="header secondary">
      <p class="headline-5 ml-10">&nbsp;</p>
    </div>-->
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
export default {
  name: 'Entete',
  computed: {
    francais: function() {
      return i18n.locale === 'fr'
    },
    connecte: function() {
      console.log('connecte=' + this.$store.getters.estAuthentifie)
      return this.$store.getters.estAuthentifie
    },
    nom: function() {
      return this.$store.getters.agentConnecteInfosJDE.nom
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    changeLocale(locale) {
      i18n.locale = locale
      this.$vuetify.lang.current = locale
    },
    afficherCreerCommande() {
      this.$store.dispatch('initialiserCommande')
      this.$router.push({ name: 'commande', params: { idCommande: null } })
    }
  }
}
</script>

<style scoped>
.header {
  padding: 0px;
  text-align: left;
  color: white;
  font-size: 12px;
}
</style>
